module.exports = __webpack_public_path__ + "static/media/phone.4b2c7364.svg";